import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("g", null, [
        _createElementVNode("g", null, [
          _createElementVNode("g", null, [
            _createElementVNode("path", {
              fill: "#FFF",
              d: "M10.43 3.485L8.622 7.152c-.036.073-.107.124-.188.136l-4.046.588c-.381.056-.733.235-1.002.51-.674.693-.66 1.8.032 2.475l2.928 2.854c.059.058.086.14.072.221l-.692 4.03c-.065.38-.003.77.176 1.11.45.856 1.508 1.185 2.364.735l3.619-1.903c.072-.038.16-.038.232 0l3.62 1.903c.34.18.73.241 1.11.176.952-.163 1.592-1.068 1.429-2.02l-.692-4.03c-.014-.082.013-.164.072-.222l2.928-2.854c.276-.268.455-.62.51-1.001.14-.957-.523-1.845-1.48-1.984l-4.046-.588c-.081-.012-.152-.063-.188-.136l-1.81-3.667c-.17-.345-.45-.624-.795-.795-.866-.427-1.916-.072-2.343.795zm1.68.55c.05.025.09.065.114.114l1.81 3.666c.255.517.747.875 1.317.958l4.047.588c.136.02.23.146.211.283-.008.054-.034.105-.073.143l-2.928 2.854c-.412.402-.6.981-.503 1.549l.691 4.03c.023.136-.068.265-.204.289-.054.009-.11 0-.159-.026l-3.619-1.902c-.51-.268-1.119-.268-1.628 0l-3.62 1.902c-.122.065-.273.018-.337-.105-.026-.048-.034-.104-.025-.158l.691-4.03c.097-.568-.09-1.147-.503-1.549L4.464 9.787c-.099-.096-.101-.255-.005-.353.039-.04.089-.065.143-.073l4.047-.588c.57-.083 1.062-.441 1.317-.958l1.81-3.666c.05-.103.163-.156.271-.135l.064.021z",
              transform: "translate(-1234 -116) translate(1230 112) translate(4 4)"
            })
          ])
        ])
      ])
    ], -1)
  ]))]))
}
export default { render: render }